

import React, {useState} from 'react';

import "./Footer.css"
import { Link } from 'react-router-dom';




function Footer() { 

    const currentYear = new Date().getFullYear();
 

  return <>
        <div className='FooterCover'>
            
        <div className='copyright'>
                <p>{`Copyright © ${currentYear} `}<Link className='linkItemz' to="https://www.unilus.ac.zm/">University of Lusaka (UNILUS)</Link></p>
        </div>
                  <div className='acredition'>
                            <p>Developed @ UNILUS IT</p>
                  </div>
         

        </div>
       
    
  </>
  
  ;
}

export default Footer;